<template>

    <div class="dropdown-container card-front-sec__info-line" v-if="this.$store.state.settings.delivery_city">

        <span class="">{{ trans('Delivery to') }}</span>
        <a class="link link_underline"
           @click="inputSearchCity = !inputSearchCity">{{$store.state.settings.delivery_city.name }}</a>

        <div class="input-wrapper input-wrapper-js" style="margin-top: 15px;" v-if="inputSearchCity">
            <span class="input-wrapper__title"></span>
            <input v-model="searchCities" type="text" class="input-element input-wrapper__element-inp"
                   @keyup="getCityList($event.target.value)">
        </div>

        <ul class="dropdown-content" v-if="citiesList.length > 0">
            <li class="dropdown-element" v-for="city in citiesList" @click="setCity(city)">
                <div class="delivery-city">
                    <span class="delivery-city__name">{{ city.name}}</span>
                    <span class="delivery-city__region">{{  city.get_region?.name }}</span>
                </div>
            </li>
        </ul>
    </div>

    <ul class="delivery-methods" v-if="card.sizes.length > 0">
        <template v-for="(delivery,index) in deliveries">
            <template v-if="index == 'stores' && delivery.length > 0">
                <li class="delivery-methods-list-item" v-for="deliv in delivery">
                    <span class="delivery-methods-list-item__title">{{ trans(deliv.name) }}</span>
                    <span>: </span>
                    <span class="delivery-methods-list-item__price">{{ deliv.price }}  </span>
                    <span class="delivery-methods-list-item__time">{{ deliv.str }}</span>
                </li>
            </template>
            <template v-if="index != 'stores' ">

                <li class="delivery-methods-list-item" v-if="delivery.name && delivery.price > 0">
                    <span class="delivery-methods-list-item__title">{{ trans(delivery.name) }}</span>
                    <span>: </span>
                    <span class="delivery-methods-list-item__price">{{
                            delivery.price
                        }} {{ delivery.currency_sign }} </span>
                    <span class="delivery-methods-list-item__time">{{ delivery.str }}</span>
                </li>
            </template>

        </template>


    </ul>
</template>

<script>
export default {
    props: {
        card: {
            type: Object,
        }
    },
name: "deliveries-card",
    data(){
        return{
            deliveries:[],
            searchCities:'',
            citiesList:[],
            inputSearchCity:false,

        }
    },
    mounted() {
        this.getDelivery()

    },
    methods:{
        setCity(city){
            this.$store.state.settings.delivery_city = city
            this.citiesList = []
            this.searchCities = ''
            this.inputSearchCity = false
            this.updateStorage(this.$store.state.settings)
            this.getDelivery()
        },
        async getCityList(search) {
            if (search.length >= 3) {
                await axios.get('/api/v1/get-cities-search', {
                    params: this.setParam({
                        search: search,
                        country_id: this.$store.state.settings.country.id,
                    })
                })
                    .then(data => {
                        this.citiesList = data.data;

                    })
            }


        },
        async getDelivery(){
            await  axios.get('/api/v1/get-delivery', {
                params:this.setParam({
                    city_id:this.$store.state.settings.delivery_city.id,
                    card_id:this.card.id,
                })
            })
                .then(data =>{

                    this.deliveries = data.data.deliveries
                    this.$store.state.settings.delivery_city = data.data.city
                    this.updateStorage(this.$store.state.settings)

                }, err => {

                })

        },

    }
}
</script>

<style scoped>

</style>
